import React from 'react';
import styled from 'styled-components';
import RichText from '../../components/RichText';
import { LinkId } from '../../constants';
import BREAK_POINTS from '../../styling/media-queries';
import { DeviceContent, DevicesSectionContent } from '../fees-and-deductibles/models';
import Title from '../fees-and-deductibles/Title';
import PageAction from './PageAction';

const s = {
  Container: styled.section`
    font-size: 14px;
    font-weight: 100;
    font-style: normal;
  `,
  Description: styled.div`
    text-align: center;
  `,
  Devices: styled.ul`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: auto;
    grid-gap: 2em 1.5em;
    list-style: none;
    text-align: center;
    padding: 0;
    margin: 1.5em;

    @media ${BREAK_POINTS.desktop} {
      grid-template-columns: repeat(4, 1fr);
    }
  `,
  DeviceItem: styled.li`
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  DeviceIcon: styled.img`
    width: 88px;
    height: 88px;
    max-width: 100%;
    object-fit: contain;
    margin-bottom: 1em;
  `,
  Buttons: styled.div`
    margin: 1em auto;
    width: fit-content;

    > *:not(:last-child) {
      margin-bottom: 1em;
    }
  `,
};

const Device = ({ icon, name }: DeviceContent) => (
  <s.DeviceItem>
    <s.DeviceIcon src={icon.fields.file.url} alt={name} />
    <span>{name}</span>
  </s.DeviceItem>
);

const DevicesSection = ({ header, subHeader, description, devices, actions }: DevicesSectionContent) => (
  <s.Container>
    <Title header={header} subHeader={subHeader} />
    <s.Description>
      <RichText content={description} />
    </s.Description>
    <s.Devices>
      {devices.map((d) => (
        <Device key={d.sys.id} {...d.fields} />
      ))}
    </s.Devices>
    <s.Buttons>
      {actions?.map(({ fields, sys }) => (
        <PageAction
          key={sys.id}
          {...fields}
          id={fields.type === 'expert' ? LinkId.WhatsCoveredNeedHelpCall : LinkId.WhatsCoveredSeeFees}
          analyticsExtras={{ElementName: header}}
        />
      ))}
    </s.Buttons>
  </s.Container>
);

export default DevicesSection;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/whats-covered/DevicesSection.tsx